import React, { FunctionComponent, useMemo } from 'react'

import {
  AuctionLinkedPropertyRecord,
  AuctionLinkedPropertyTableView,
} from '../../../common/auctionMonitoringTypes'
import { useAuctionLinkedPropertyQuery } from '../../../graphql/generated'
import { useAppSelector } from '../../../redux/hooks'
import { useGeneralPropertyLabels } from '../../utils/usePropertiesLabels'
import { usePropertyTableNoteCheck } from '../../utils/usePropertyTableNoteCheck'
import { AuctionMonitoringLinkedPropertyHelpModalButton } from '../AuctionMonitoringLinkedPropertyHelpModalButton/AuctionMonitoringLinkedPropertyHelpModalButton'
import { AuctionMonitoringLinkedPropertyTable } from '../AuctionMonitoringLinkedPropertyTable/AuctionMonitoringLinkedPropertyTable'

export interface AuctionMonitoringLinkedPropertyTableContainerProps {
  auctionId: string
  viewType: AuctionLinkedPropertyTableView
  activePropertyId?: string
}

export const AuctionMonitoringLinkedPropertyTableContainer: FunctionComponent<AuctionMonitoringLinkedPropertyTableContainerProps> =
  props => {
    const { tenantId } = useAppSelector(state => state.myProfile)

    const [queryResult] = useAuctionLinkedPropertyQuery({
      requestPolicy: 'cache-first',
      variables: { accountId: tenantId, auctionId: props.auctionId },
    })

    const { dataSource, propertyIds } = useMemo(() => {
      const data =
        (queryResult?.data?.allAuctionProperties?.nodes?.filter(
          item => !!item
        ) as AuctionLinkedPropertyRecord[]) || []
      const ids = data?.map(item => item?.propertyId)

      return { dataSource: data, propertyIds: ids }
    }, [queryResult?.data?.allAuctionProperties?.nodes])

    const propertyNotes = usePropertyTableNoteCheck(propertyIds)
    const { propertyLabels, loading: labelsLoading } =
      useGeneralPropertyLabels(propertyIds)

    return (
      <>
        <AuctionMonitoringLinkedPropertyTable
          data={dataSource}
          auctionId={props.auctionId}
          propertyNotes={propertyNotes}
          propertyLabels={labelsLoading ? 'loading' : propertyLabels}
          viewType={props.viewType}
          activePropertyId={props.activePropertyId}
        />
        {props.viewType === 'drawer' && !dataSource?.length && (
          <AuctionMonitoringLinkedPropertyHelpModalButton />
        )}
      </>
    )
  }
